import { Injectable } from '@angular/core';
import { MnemonicFabricCanvas } from '../fabric/fabric-canvas.types';
import {
    buildMnemonicImageUrl,
    deserializeMnemonicCanvas,
    initializeMnemonicFabricRuntime,
    MnemonicCanvasLoadOptions,
    MnemonicCanvasSaveOptions,
    serializeMnemonicCanvas,
} from '../fabric';

/**
 * Facade — единая точка входа для работы с Fabric-canvas мнемосхемы.
 */
@Injectable({
    providedIn: 'root',
})
export class MnemonicCanvasFacade {
    initialize(): void {
        initializeMnemonicFabricRuntime();
    }

    serialize(canvas: MnemonicFabricCanvas, options: MnemonicCanvasSaveOptions = {}): Record<string, unknown> {
        return serializeMnemonicCanvas(canvas, options);
    }

    async deserialize(canvas: MnemonicFabricCanvas, raw: unknown, options: MnemonicCanvasLoadOptions = {}): Promise<void> {
        await deserializeMnemonicCanvas(canvas, raw, options);
    }

    buildImageUrl(fileName: string): string {
        return buildMnemonicImageUrl(fileName);
    }
}
